function escapeCsvValue(value: string): string {
    const escapedValue = value.replace(/"/g, '""');
    if (escapedValue.includes(';') || escapedValue.includes('\n')) {
        return `"${escapedValue}"`;
    }
    return escapedValue;
}

export function convertArrayToCSV(data: Record<string, unknown>[], headers: { key: string; label: string }[] = []): string {
    const csv: string[] = [];
    const heads: string[] = headers.length === 0 ? Object.keys(data[0]) : headers.map((header) => header.key);

    csv.push(headers.length === 0 ? heads.map(escapeCsvValue).join(';') : headers.map((header) => header.label).join(';'));

    data.forEach((item: Record<string, unknown>) => {
        const values = heads.map((header) => {
            const value = item[header] != null ? item[header] : '';
            return escapeCsvValue(String(value));
        });
        csv.push(values.join(';'));
    });

    return csv.join('\n');
}
